import React, { Component } from "react";
import {withRouter, Link} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import ReactPaginate from 'react-paginate';

import {PageWrapper} from 'components/PageWrapper';

import HttpClient from 'services/HttpClient';

const SAMPLE_CONTENT_API = '/api/v1/free_samples';

@withRouter
@inject('sampleContentStore')
@observer
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalPages: 1,
    };
  }

  componentDidMount() {
    const { sampleContentStore } = this.props;

    new HttpClient().get(`${SAMPLE_CONTENT_API}?page=1&per_page=10`)
    .then(({ body }) => {
      sampleContentStore.setSampleContentList(body.data.free_sample);

      this.setState({
        totalPages: body.data.total_pages,
      });
    })
  }

  nextPage = page => {
    const { sampleContentStore } = this.props;

    new HttpClient().get(`${SAMPLE_CONTENT_API}?page=${page.selected + 1}&per_page=10`).then(({body}) => {
      sampleContentStore.setSampleContentList(body.data.free_sample);

      this.setState({
        totalPages: body.data.total_pages,
      });
      window.scrollTo({top: 0});
    });
  };

  render() {
    const { sampleContentStore: { sampleContentList } } = this.props;
    const { totalPages } = this.state;

    return (
      <PageWrapper>
        <div className="page-container">
          <h2>Sample Content</h2>
        </div>
        <Link to='/sample-content/add'>+ Add New Sample Content</Link>
        <div className="row">
          <div className="container">
            <div className="mcq-questions-list">
              {sampleContentList.length > 0 ? sampleContentList.map((content) => (
                <Link
                  to={`/sample-content/${content.id}/edit`}
                  key={`content_${content.id}`}
                >
                  {content.title}
                </Link>
              )) : (
                <div className="empty-list-container">
                  <span className="self-center">There is no sample content</span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="pagination-container">
          <ReactPaginate
            containerClassName="react-paginate"
            pageCount={totalPages}
            onPageChange={this.nextPage}
          />
        </div>
      </PageWrapper>
    );
  }
};

export default List;



// WEBPACK FOOTER //
// ./src/modules/admin/sampleContent/containers/List.js